import { useSelector } from "react-redux";
import { CartProduct } from "../interfaces/Cart";
import { StoreState } from "../interfaces/storeState";

export const useCartSelectionsProduct = (): CartProduct =>
  useSelector(getCartSelectionsProduct);

const getCartSelectionsProduct = (state: StoreState): CartProduct => {
  if (!state.cartSelections?.product) {
    return undefined;
  }

  return state.cartSelections.product;
};
